export const GLOBALIZATION_INTL = "globalization-intl";
export const GLOBALIZATION_NUMBER_TYPES = "globalization-number-types";
export const GLOBALIZATION_SUBNET_INTL = "globalization-subnet-intl";

export const CREATE_TEXT_OK = "Created successfully";
export const CREATE_TEXT_KO = "Could not create";
export const DELETE_TEXT_OK = "Deleted successfully";
export const DELETE_TEXT_KO = "Could not delete";
export const EDITED_TEXT_OK = "Update successfully";
export const EDITED_TEXT_KO = "Could not update";
export const TOAST_DURATION = 2000;

export const ADMIN = "admin";
export const INTERNATIONAL_FIELDS_EDIT = "international_fields";

export const INTERNATIONAL_NUMBERING_CREATE = "international_details_create";
export const INTERNATIONAL_NUMBERING_FIELDS_EDIT =
  "international_details_fields";
export const INTERNATIONAL_NUMBERING_DELETE = "international_details_delete";

export const INTERNATIONAL_LNP_CREATE = "lnp_details_create";
export const INTERNATIONAL_LNP_FIELDS_EDIT = "lnp_details_fields";
export const INTERNATIONAL_LNP_DELETE = "lnp_details_delete";

export const INTERNATIONAL_NUMBER_TYPE_CREATE = "number_type_create";
